var render = function () {
  var _vm=this;
  var _h=_vm.$createElement;
  var _c=_vm._self._c||_h;

  return _c('div', [_vm.show ? _c('b-form', {
    on: {
      "submit": _vm.onSubmit,
      "reset": _vm.onReset
    }
  }, [_c('b-form-row', [_c('b-col', [_c('b-form-group', {
    attrs: {
      "label": "Letnica rojstva"
    }
  }, [_c('b-form-select', {
    attrs: {
      "options": _vm.yearOptions,
      "required": "",
      "id": "year-select"
    },
    model: {
      value: _vm.form.birthyear,
      callback: function callback($$v) {
        _vm.$set(_vm.form, "birthyear", $$v);
      },
      expression: "form.birthyear"
    }
  }), _c('b-form-text', {
    attrs: {
      "id": "password-help-block"
    }
  }, [_vm._v(" Sodelovanje na voljo zgolj osebam, ki so starejše od 15 let. ")])], 1)], 1)], 1), _c('b-form-row', {}, [_c('b-col', [_c('b-form-group', {
    attrs: {
      "label": "Spol"
    }
  }, [_c('b-form-radio-group', {
    attrs: {
      "required": "",
      "id": "radio-sex",
      "options": _vm.sexOptions,
      "buttons": "",
      "button-variant": "secondary",
      "name": "radio-sex"
    },
    model: {
      value: _vm.form.sex,
      callback: function callback($$v) {
        _vm.$set(_vm.form, "sex", $$v);
      },
      expression: "form.sex"
    }
  })], 1)], 1)], 1), _c('b-form-row', [_c('b-col', [_c('b-form-checkbox', {
    staticClass: "small",
    attrs: {
      "id": "checkbox-1",
      "name": "checkbox-1",
      "value": "1",
      "unchecked-value": "1",
      "required": ""
    },
    model: {
      value: _vm.form.termsagree,
      callback: function callback($$v) {
        _vm.$set(_vm.form, "termsagree", $$v);
      },
      expression: "form.termsagree"
    }
  }, [_vm._v(" Strinjam se s "), _c('b-link', {
    attrs: {
      "target": "_blank",
      "href": "https://brevisvelox.com/#/terms"
    }
  }, [_vm._v("Splošnimi pogoji")]), _vm._v(" in "), _c('b-link', {
    attrs: {
      "target": "_blank",
      "href": "https://brevisvelox.com/#/privacy"
    }
  }, [_vm._v("Politiko zasebnosti")]), _vm._v(". ")], 1)], 1)], 1), _c('b-form-row', {
    staticClass: "mt-4"
  }, [_c('b-col', [_c('b-button', {
    attrs: {
      "type": "submit",
      "variant": "primary"
    }
  }, [_vm._v("Pričnite z raziskavo")])], 1)], 1)], 1) : _vm._e(), _c('b-sidebar', {
    attrs: {
      "id": "sidebar-terms",
      "shadow": "",
      "right": "",
      "lazy": "",
      "width": "50rem",
      "backdrop": ""
    }
  }, [_vm._v(" TERMS! ")]), _c('b-sidebar', {
    attrs: {
      "id": "sidebar-privacy",
      "shadow": "",
      "right": "",
      "lazy": "",
      "width": "50rem",
      "backdrop": ""
    }
  }, [_vm._v(" PRIVACY ")])], 1);
}
var staticRenderFns = []

export { render, staticRenderFns }